import { get } from '../utils/axios'

export const orgsAllAPI = async (body) => {
  return await get('/orgs', body)
}


